import React from 'react';
import {AisinoFormItem} from "../../../baseComponent/form";
import AisinoTextArea from "../../../baseComponent/form/input/AisinoTextArea";
import {formItemTailLayout} from "../../../constant/css";
import {validateStrLength} from "../../../source/js/common";
import {isEmpty} from "../../utils/StringUtils";
import {DatabaseType} from "../../../dictionary";


class FormItemTextArea extends React.Component {
    state={
        name:this.props.name,
        maxLength:""
    };
    shouldUpdate(prevValue,curValue){
        const name=this.state.name;
        const maxLength=this.state.maxLength;
        if(name&&curValue[name]&&maxLength&&curValue[name].length>maxLength){
            curValue[name]=curValue[name].substr(0,maxLength)
        }
        return true;
    }
    render() {
        let styleBg = false
        this.props.rules?this.props.rules.forEach(item=>{
            if(item.required){
                styleBg = item.required
            }
        }):""
        let maxLength=this.props.maxLength;
        let rules=[];
        if(this.props.rules){
            rules=[...this.props.rules];
        }
        if(maxLength||rules.length){
            let databaseType=sessionStorage.getItem("databaseType");
            if(maxLength){
                this.state.maxLength=maxLength;
                if(isEmpty(databaseType)||databaseType===DatabaseType.ORACLE){
                    rules.push({validator:(rule,value)=>{ return validateStrLength(value, maxLength)}})
                }
            }else if(rules.length){
                rules.forEach(item=>{
                    if(item.max){
                        maxLength=item.max;
                    }
                });
                if(maxLength){
                    this.state.maxLength=maxLength;
                    if(isEmpty(databaseType)||databaseType===DatabaseType.ORACLE){
                        rules.push({validator:(rule,value)=>{ return validateStrLength(value, maxLength)}})
                    }
                }
            }
        }

        //控制必填项不能只输入空格
        if (styleBg){
            rules.push({'whitespace':true});
        }

        return(
            <div className="divAisinoFormItem">
                <AisinoFormItem {...formItemTailLayout} shouldUpdate={(prevValue,curValue)=>this.shouldUpdate(prevValue,curValue)} {...this.props}  rules={rules} >
                    <AisinoTextArea disabled={this.props.disabled} style={styleBg?{background:"#ffffe6"}:{}} maxLength={maxLength} autoSize={this.props.autoSize}/>
                </AisinoFormItem>
            </div>
        );
    }
}
export default FormItemTextArea;